
import { GET_USER_INFO, GET_USER_INFO_FAILED, GET_USER_INFO_SUCCESS, USER_NOTIFICATION_SETTINGS } from '../../constants/userConstant';

const initialState = {
    data: {},
    pagination: {
        page: 1
    },
    settings:{
        notification: {}
    },
    isLoading: false,
    error: null
};

export default function userReducer(state = initialState, action) {
    switch (action.type) {
        case GET_USER_INFO:
            return {
                ...state,
                isLoading: true,
                error: null
            };

        case GET_USER_INFO_SUCCESS:
            return {
                ...state,
                isLoading: false,
                data: action.payload.data,
            };

        case USER_NOTIFICATION_SETTINGS:
            return {
                ...state,
                isLoading: false,
                settings:{
                    notification: action.payload.data
                }
            };

        case GET_USER_INFO_FAILED:
            return {
                ...state,
                isLoading: false,
                error: action.payload
            };

        default:
            return state;
    }
}